import { footerGroups } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500"></div>
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-base font-heading font-bold tracking-tight text-foreground-950">
                  黑料网站
                </span>
                <span className="mt-1 text-[10px] font-label uppercase tracking-[0.22em] text-foreground-500">
                  Entry Portal
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-foreground-600">
              本页持续整理黑料网站入口、地址、备用与镜像链接，随时回来刷新即可获取最新可用地址，换链接防走丢一手掌握。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-label text-foreground-600">
                <span className="w-3.5 h-3.5 flex items-center justify-center text-secondary-600">
                  <i className="ri-shield-check-line text-sm" aria-hidden="true"></i>
                </span>
                每日多次巡检
              </span>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-label text-foreground-600">
                <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-600">
                  <i className="ri-history-line text-sm" aria-hidden="true"></i>
                </span>
                更新可追溯
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7 lg:gap-8">
            {footerGroups.map((group) => (
              <div key={group.id}>
                <h3 className="text-xs font-label uppercase tracking-[0.16em] text-foreground-500">
                  {group.title}
                </h3>
                <ul className="mt-4 space-y-3">
                  {group.links.map((link) => (
                    <li key={link.id}>
                      <a
                        href={link.href}
                        className="whitespace-nowrap text-sm font-label text-foreground-700 transition-colors hover:text-primary-600"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-50 p-5">
          <p className="text-xs leading-6 text-foreground-500">
            免责声明：本站为资讯与入口汇总页面，内容均整理自公开渠道，仅供信息参考与收藏使用。请遵守所在地区的相关法律法规，理性浏览，本站不对第三方站点内容负责。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs font-label text-foreground-500">
            © 2026 黑料网站入口汇总 · 保留所有权利
          </p>
          <div className="flex flex-wrap items-center gap-5">
            <a href="#guide" className="whitespace-nowrap text-xs font-label text-foreground-500 transition-colors hover:text-primary-600">
              收藏指南
            </a>
            <a href="#faq" className="whitespace-nowrap text-xs font-label text-foreground-500 transition-colors hover:text-primary-600">
              浏览须知
            </a>
            <a href="#mirrors" className="whitespace-nowrap text-xs font-label text-foreground-500 transition-colors hover:text-primary-600">
              节点状态
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}